import { Box, Button, Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import { useState } from "react";
import { P } from "theme/typography";
import { isNumber, parseSafeInt } from "Backend";
import { useSnackbar } from "notistack";

const PasteCasesDialog = (props: { open: boolean; onConfirm: (caseIds: number[]) => void; onCancel: () => void }) => {
  const { open, onConfirm, onCancel } = props;
  const [paste, setPaste] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Dialog open={open}>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: 400,
        }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}>
          <P variant="lgBold">Paste Case IDs</P>
          <P variant="sm">Cases can be comma or whitespace separated</P>
        </Box>
        <TextField
          autoFocus
          fullWidth
          label="Paste here"
          multiline
          rows={4}
          value={paste}
          onChange={(evt) => {
            setPaste(evt.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          disabled={paste.length === 0}
          variant="contained"
          onClick={() => {
            const cases = paste
              // Single comma or whitespace regex
              .split(/,|\s+/)
              .map(parseSafeInt);
            const validCases = cases.filter(isNumber);
            const anyInvalid = validCases.length !== cases.length;

            if (anyInvalid) {
              enqueueSnackbar("Invalid case IDs", { variant: "error" });
            } else {
              onConfirm(validCases);
            }
          }}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasteCasesDialog;
